     document.addEventListener('DOMContentLoaded', function () {
         const isThemeEditor = window.Shopify && window.Shopify.designMode;
         if (isThemeEditor) {
             document.body.classList.add('shopify-design-mode');
         }

         const animatedSections = document.querySelectorAll('.shopify-section-animation');
         if (isThemeEditor) {
             animatedSections.forEach(function (section) {
                 section.classList.add('is-visible');
             });
             return;
         }

         const observerOptions = {
             threshold: 0.1,
             rootMargin: '0px 0px -50px 0px',
         };

         const observer = new IntersectionObserver(function (entries) {
             entries.forEach(function (entry) {
                 if (entry.isIntersecting) {
                     entry.target.classList.add('is-visible');
                     observer.unobserve(entry.target);
                 }
             });
         }, observerOptions);

         animatedSections.forEach(function (section) {
             observer.observe(section);
         });

         //  document.querySelectorAll('a[href]').forEach((link) => {
         //      link.addEventListener('click', (e) => {
         //          const href = link.getAttribute('href');
         //          if (href && !href.startsWith('#') && !href.startsWith('http') && !link.hasAttribute('target')) {
         //              e.preventDefault();
         //              document.body.classList.add('page-transitioning');
         //              setTimeout(() => {
         //                  window.location.href = href;
         //              }, 140);
         //          }
         //      });
         //  });

         // Fade in when page loads
         window.addEventListener('pageshow', (event) => {
             document.body.classList.remove('page-transitioning');
             document.body.classList.add('page-loaded');
         });

         // Fade out when leaving page
         window.addEventListener('pagehide', (event) => {
             document.body.classList.add('page-transitioning');
         });
});